/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ProxyChallengeOptions } from './ProxyChallengeOptions';
import {
    ProxyChallengeOptionsFromJSON,
    ProxyChallengeOptionsFromJSONTyped,
    ProxyChallengeOptionsToJSON,
} from './ProxyChallengeOptions';

/**
 * 
 * @export
 * @interface ProxyChallengeAllOf
 */
export interface ProxyChallengeAllOf {
    /**
     * 
     * @type {ProxyChallengeOptions}
     * @memberof ProxyChallengeAllOf
     */
    options?: ProxyChallengeOptions;
}

/**
 * Check if a given object implements the ProxyChallengeAllOf interface.
 */
export function instanceOfProxyChallengeAllOf(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ProxyChallengeAllOfFromJSON(json: any): ProxyChallengeAllOf {
    return ProxyChallengeAllOfFromJSONTyped(json, false);
}

export function ProxyChallengeAllOfFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProxyChallengeAllOf {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'options': !exists(json, 'options') ? undefined : ProxyChallengeOptionsFromJSON(json['options']),
    };
}

export function ProxyChallengeAllOfToJSON(value?: ProxyChallengeAllOf | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'options': ProxyChallengeOptionsToJSON(value.options),
    };
}

